import axios from 'axios';
import logger from '../utils/logger';
var log = logger.createLogger('apiSchema');
function fetchStaticApiSchema() {
  log.warn('fetching static api schema (dev?)');
  return {
    "compute": {
      "cugraph": ["betweenness_centrality", "katz_centrality", "ecg", "leiden", "louvain", "spectralBalancedCutClustering", "spectralModularityMaximizationClustering", "connected_components", "strongly_connected_components", "weakly_connected_components", "core_number", "hits", "pagerank", "bfs", "bfs_edges", "sssp", "shortest_path", "shortest_path_length", "batched_ego_graphs", "edge_betweenness_centrality", "jaccard", "jaccard_w", "overlap", "overlap_coefficient", "overlap_w", "sorensen", "sorensen_coefficient", "sorensen_w", "ego_graph", "k_core", "minimum_spanning_tree"],
      "igraph": ["authority_score", "betweenness", "bibcoupling", "harmonic_centrality", "closeness", "clusters", "cocitation", "community_edge_betweenness", "community_fastgreedy", "community_infomap", "community_label_propagation", "community_leading_eigenvector", "community_leiden", "community_multilevel", "community_spinglass", "community_walktrap", "constraint", "gomory_hu_tree", "hub_score", "eccentricity", "eigenvector_centrality", "k_core", "pagerank", "spanning_tree"]
    },
    "layout": {
      "cugraph": ["force_atlas2"],
      "igraph": ["auto", "automatic", "bipartite", "circle", "circular", "dh", "davidson_harel", "drl", "drl_3d", "fr", "fruchterman_reingold", "fr_3d", "fr3d", "fruchterman_reingold_3d", "grid", "grid_3d", "graphopt", "kk", "kamada_kawai", "kk_3d", "kk3d", "kamada_kawai_3d", "lgl", "large", "large_graph", "mds", "random", "random_3d", "rt", "tree", "reingold_tilford", "rt_circular", "reingold_tilford_circular", "sphere", "spherical", "circle_3d", "circular_3d", "star", "sugiyama"]
    },
    "types": {
      "CuGraphKind": ["Graph", "MultiGraph", "BiPartiteGraph"]
    }
  };
}
var out = undefined;

// () -> {"compute": {str -> array<str>}, "layout": {str -> array<str>}, "types": {...}}
export function fetchApiSchema() {
  if (out) {
    return out;
  }

  //FIXME some reason axios is not inferring HTTPS on TLS sites
  out = axios.get('/web/v2/schema/compute/').then(function (response) {
    var _response$data;
    // Handle different response structures
    var data = ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) || response.data;
    if (data && data.compute && data.layout) {
      return data;
    }
    log.warn({
      response: response.data
    }, 'Unexpected API schema response structure, using static schema');
    return fetchStaticApiSchema();
  }).catch(function (e) {
    if (e && e.response && e.response.status === 404) {
      log.debug('/schema/compute response 404, likely dev, use baked');
      return fetchStaticApiSchema();
    }
    log.error({
      e: e
    }, '/web/v2/schema/compute/ error, using static schema');
    return fetchStaticApiSchema();
  });
  return out;
}
export function emptyApiSchema() {
  return {
    "compute": {
      "cugraph": [],
      "igraph": []
    },
    "layout": {
      "cugraph": [],
      "igraph": []
    },
    "types": {}
  };
}